import { Analytics } from './Firebase';

export const FirebaseAnalytics = Analytics;
